<script setup lang="ts" generic="T">
import { onMounted, useSlots } from "vue";
import AlertComponent from "@/components/AlertComponent.vue";


interface Props {
  confirming: boolean;
  coincidences: T[];
  title: string;
  createButtonText: string;
  body?: string;
  dismiss?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}

interface Emits {
  (event: "update:confirming", value: boolean): void;
}

withDefaults(defineProps<Props>(), {
  type: "success",
  dismiss: true,
  body: "Se encontraron algunas coincidencias con el nombre similar al que desea crear.",
  onConfirm: () => null,
  onCancel: () => null,
});
const slots = useSlots();
const emits = defineEmits<Emits>();

onMounted(() => {
  if (!slots["coincidence"]) {
    throw new Error('The slot "coincidence" is required');
  }
});
</script>

<template>
  <AlertComponent
    :model-value="confirming"
    type="warning"
    :dismiss="dismiss"
    :on-cancel="onCancel"
    :on-confirm="onConfirm"
    @update:model-value="emits('update:confirming', $event)"
  >
    <template #title>
      {{ title }}
    </template>

    <template #body>
      <span class="mb-2"
        >{{ body }}</span
      >

      <ul class="list-inside list-disc">
        <li
          v-for="coincidence, index in coincidences.slice(0, 5)"
          :key="index"
        >
          <slot name="coincidence" :coincidence="coincidence" />
        </li>
      </ul>

      <span class="ml-auto text-right font-bold mt-2"
        >¿Aún así desea continuar?</span
      >
    </template>

    <template #closeButton> Cancelar </template>
    <template #button> {{ createButtonText }} </template>
  </AlertComponent>
</template>

<style scoped></style>
